import { render, staticRenderFns } from "./setDialog.vue?vue&type=template&id=ed2e8496&scoped=true"
import script from "./setDialog.vue?vue&type=script&lang=js"
export * from "./setDialog.vue?vue&type=script&lang=js"
import style0 from "./setDialog.vue?vue&type=style&index=0&id=ed2e8496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9b90bd239842d9ab132761d251f24808/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2e8496",
  null
  
)

export default component.exports